import React from "react";

/**
 * Logo oficial del XIII Cross de Carme.
 * Responsive: s'adapta a mòbil sense tallar-se.
 */
const SIZES = {
  sm: { xiii: "text-lg sm:text-xl px-1.5 sm:px-2 py-0.5", main: "text-lg sm:text-xl", small: "text-xs sm:text-sm" },
  md: { xiii: "text-xl sm:text-2xl px-2 sm:px-2.5 py-0.5", main: "text-2xl sm:text-3xl", small: "text-base sm:text-lg" },
  lg: { xiii: "text-3xl sm:text-4xl px-2.5 sm:px-3 py-1", main: "text-4xl sm:text-5xl", small: "text-2xl sm:text-3xl" },
  xl: { xiii: "text-4xl sm:text-5xl md:text-6xl px-2.5 sm:px-3 md:px-4 py-1", main: "text-5xl sm:text-6xl md:text-7xl", small: "text-3xl sm:text-4xl md:text-5xl" },
  hero: { xiii: "text-5xl sm:text-7xl md:text-9xl px-3 sm:px-4 md:px-5 py-1.5 sm:py-2", main: "text-5xl sm:text-7xl md:text-9xl", small: "text-3xl sm:text-5xl md:text-7xl" },
};

export default function Logo({ size = "md", onDark = false, className = "" }) {
  const s = SIZES[size] || SIZES.md;
  const darkTone = onDark ? "text-white" : "text-[#0E1410]";

  return (
    <span
      className={`inline-flex flex-wrap items-center gap-1.5 sm:gap-2 md:gap-3 font-black italic select-none max-w-full ${className}`}
      style={{ fontFamily: "'Archivo Black', 'Oswald', sans-serif" }}
      aria-label="Cross de Carme"
    >
      <span className={`text-[#E94E1B] tracking-tight leading-none ${s.main}`}>CROSS</span>
      <span className={`${darkTone} tracking-tight leading-none ${s.small} lowercase whitespace-nowrap`}>
        de <span className="uppercase">CARME</span>
      </span>
    </span>
  );
}
